import { LocalStorageService } from '../LocalStorageService'

const UniqueUserIdService = {

    uniqueUserIdKey: 'uuId',
    /** Generate unique guid
     */
    generateUniqueUserId: () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    },
    /** Set Unique User Id */
    setUniqueUserId:(uniqueUserId) => {
        let localUserId = LocalStorageService.get(UniqueUserIdService.uniqueUserIdKey);
        if (uniqueUserId && localUserId !== uniqueUserId) {
            LocalStorageService.set(UniqueUserIdService.uniqueUserIdKey, uniqueUserId);
        }
        return uniqueUserId;
    },
    /** Get Unique User Id
     * @return {string} Checking if cookies accepted or not
    */
    getUniqueUserId: () => {
        let localUserId = LocalStorageService.get(UniqueUserIdService.uniqueUserIdKey);
        if(!localUserId){
            localUserId = UniqueUserIdService.generateUniqueUserId();
            UniqueUserIdService.setUniqueUserId(localUserId);
        }
        return localUserId;
    },
}
export default UniqueUserIdService;